import { displayLog } from "../../Helper/helper";
import { getCreditDetailsData, getSellerData, postUserProfileImage } from "../../Services/user.services";
import { addUnverifiedAccountDataFromAccessTokenAction, addUnverifiedAccountDataFromAccessTokenDoneAction, addUnverifiedAccountDataFromAccessTokenErrorAction, getCreditDetailsAction, getCreditsDetailErrorsAction, getCreditsDetailsDoneAction, getDashboardDetailErrorsAction, getDashboardDetailsAction, getDashboardDetailsDoneAction, setUserProfilePictureDoneAction, setUserProfilePictureErrorAction } from "../actions/user.action";
import errorMsg from "../../Fixures/errorMessages.json";




export const getSellerDashboardDetails = (marketType = "open") => async (dispatch) => {
   try {
      dispatch(getDashboardDetailsAction({ marketType }));
      const res = await getSellerData(marketType);
      if (res) {
         if (res.error) {
            dispatch(getDashboardDetailErrorsAction(res.error));
         }
         dispatch(getDashboardDetailsDoneAction({ ...res.data, marketType }));
      }
   } catch (error) {
      dispatch(getDashboardDetailErrorsAction(error.message));
   }
}
export const getSellerCreditsDataDetails = () => async (dispatch) => {
   try {
      dispatch(getCreditDetailsAction());

      const res = await getCreditDetailsData();
      if (res) {
         if (res.error) {
            dispatch(getCreditsDetailErrorsAction(res.error));
         }
         dispatch(getCreditsDetailsDoneAction(res.data));
      }
   } catch (error) {
      dispatch(getCreditsDetailErrorsAction(error.message));
   }
}
export const setUserProfilePicture = (image) => async (dispatch) => {
   try {
      const imageFormData = new FormData();
      imageFormData.append("usersPic", image);

      const response = await postUserProfileImage(imageFormData);

      if (response) {
         if (response.error) {
            dispatch(setUserProfilePictureErrorAction(response.error));
            return;
         }
         displayLog("success", errorMsg.notificationMsg.profilePictureUploadSuccess);
         dispatch(setUserProfilePictureDoneAction(response.data));
      } else {
         displayLog("error", errorMsg.errorMsg.profilePictureUploadFailed);
      }
   } catch (error) {
      error.message
         ? displayLog("error", error.message)
         : displayLog("error", errorMsg.errorMsg.profilePictureUploadFailed);
      dispatch(setUserProfilePictureErrorAction());
   }
}

export const getSellerDwollaAccountDetailsFromAccessTokenData = (accessTokenData) => async (dispatch) => {
   try {
      dispatch(addUnverifiedAccountDataFromAccessTokenAction());
      dispatch(addUnverifiedAccountDataFromAccessTokenDoneAction(accessTokenData));
      // const res = await getSellerData(accessTokenData);
      // if (res) {
      //    if (res.error) {
      //       dispatch(getDashboardDetailErrorsAction(res.error));
      //    }
      //    dispatch(getDashboardDetailsDoneAction(res.data));
      // }
   } catch (error) {
      dispatch(addUnverifiedAccountDataFromAccessTokenErrorAction(error.message));
   }
}